import { Loader as KendoLoader } from '@progress/kendo-react-indicators';
export const Loader = () => {
  return <KendoLoader
    type='converging-spinner'
    className='setup-custom-loader'
    style={{ width: '100%', height: '100%' }} />
}
